export const MAP_STATUS_FORM_TO_API: Record<string, number> = {
  true: 1, // 1 - активна
  false: 2, // 2 - неактивна
};

export const MAP_STATUS_API_TO_FORM: Record<number, boolean> = {
  1: true, // 1 - активна
  2: false, // 2 - неактивна
};
